import { render, staticRenderFns } from "./deletePartnerDialog.vue?vue&type=template&id=7e183a96&scoped=true"
import script from "./deletePartnerDialog.vue?vue&type=script&lang=ts"
export * from "./deletePartnerDialog.vue?vue&type=script&lang=ts"
import style0 from "./deletePartnerDialog.vue?vue&type=style&index=0&id=7e183a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e183a96",
  null
  
)

export default component.exports